import { NgModule } from "@angular/core";
import {
  NgbAlertModule,
  NgbCarouselModule,
  NgbDropdownConfig,
  NgbDropdownModule,
  NgbModalModule,
  NgbPopoverConfig,
  NgbPopoverModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";

const ngbModules = [
  NgbModalModule,
  NgbDropdownModule,
  NgbCarouselModule,
  NgbTooltipModule,
  NgbPopoverModule,
  NgbAlertModule,
];

@NgModule({
  imports: ngbModules,
  exports: ngbModules,
})
export class NgbModule {
  constructor(
    popoverConfig: NgbPopoverConfig,
    dropdownConfig: NgbDropdownConfig
  ) {
    popoverConfig.autoClose = "outside";
    dropdownConfig.container = "body";
  }
}
